import {
  GET_MANUAL_ORDER_AUDIT_ERROR_DOWNLOAD,
  GET_MANUAL_ORDER_AUDIT_REQUEST_DOWNLOAD,
  GET_MANUAL_ORDER_AUDIT_SUCCESS_DOWNLOAD,
  CLEAR_AUDIT_DATA,
  GET_MANUAL_ORDER_AUDIT_RESET_DOWNLOAD,
} from "redux/actions/action-type";

const initialState = {
  csvAuditData: [],
  isDownloadManualOrdersAuditErrorLoading: false,
  isDownloadManualOrdersAuditError: false,
  isDownloadManualOrdersAuditSuccess: false,
};

const downloadManualOrdersAuditReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MANUAL_ORDER_AUDIT_REQUEST_DOWNLOAD:
      return {
        ...state,
        isDownloadManualOrdersAuditErrorLoading: true,
        isDownloadManualOrdersAuditError: false,
        isDownloadManualOrdersAuditSuccess: false,
      };

    case GET_MANUAL_ORDER_AUDIT_SUCCESS_DOWNLOAD:
      return {
        ...state,
        isDownloadManualOrdersAuditErrorLoading: false,
        csvAuditData: action.payload,
        isDownloadManualOrdersAuditError: false,
        isDownloadManualOrdersAuditSuccess: true,
      };

    case GET_MANUAL_ORDER_AUDIT_ERROR_DOWNLOAD:
      return {
        ...state,
        isDownloadManualOrdersAuditErrorLoading: false,
        csvAuditData: [],
        isDownloadManualOrdersAuditError: true,
        isDownloadManualOrdersAuditSuccess: false,
      };

    case CLEAR_AUDIT_DATA:
      return {
        ...state,
        csvAuditData: [],
      };

    case GET_MANUAL_ORDER_AUDIT_RESET_DOWNLOAD:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default downloadManualOrdersAuditReducer;
